<template>
<div class="content">
    <div class="container-fluid">
    <div class="row">
        <div class="col-md-12">
            <coaching-record>
            </coaching-record> 
        </div>
    </div>  
    </div>
</div>
</template>
<script>
/* eslint-disable */
import coachingRecord from './todo-coaching-record'
export default {
    components: {
        coachingRecord
    }
}
</script>
<style lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-employee-management/base-coaching-record.vue